/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * PostHog API - 1 ops
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod'

import { WidgetAssigneeFilter } from './widgetAssigneeFilter.zod'
import { WidgetDateRange } from './widgetDateRange.zod'
import { WidgetFilterEntry } from './widgetFilterEntry.zod'

export const errorTrackingListWidgetConfigLimitDefault = 10
export const errorTrackingListWidgetConfigLimitMax = 25

export const errorTrackingListWidgetConfigOrderByDefault = `occurrences`
export const errorTrackingListWidgetConfigOrderDirectionDefault = `DESC`
export const errorTrackingListWidgetConfigStatusDefault = `active`

export const ErrorTrackingListWidgetConfig = /* @__PURE__ */ zod.object({
    dateRange: zod.union([WidgetDateRange, zod.null()]).optional(),
    filterTestAccounts: zod.union([zod.boolean(), zod.null()]).optional(),
    widgetFilters: zod.union([zod.record(zod.string(), WidgetFilterEntry), zod.null()]).optional(),
    limit: zod
        .number()
        .min(1)
        .max(errorTrackingListWidgetConfigLimitMax)
        .default(errorTrackingListWidgetConfigLimitDefault)
        .describe('Maximum number of issues to return.'),
    orderBy: zod
        .enum(['last_seen', 'first_seen', 'occurrences', 'users', 'sessions'])
        .default(errorTrackingListWidgetConfigOrderByDefault)
        .describe('Issue ranking column.'),
    orderDirection: zod
        .enum(['ASC', 'DESC'])
        .default(errorTrackingListWidgetConfigOrderDirectionDefault)
        .describe('Sort direction for orderBy.'),
    status: zod
        .enum(['archived', 'active', 'resolved', 'pending_release', 'suppressed', 'all'])
        .default(errorTrackingListWidgetConfigStatusDefault)
        .describe('Issue status filter.'),
    assignee: zod
        .union([WidgetAssigneeFilter, zod.null()])
        .optional()
        .describe('Filter by assignee ({type: user|role, id}). Omit for any assignee.'),
})

export type ErrorTrackingListWidgetConfig = zod.input<typeof ErrorTrackingListWidgetConfig>
export type ErrorTrackingListWidgetConfigOutput = zod.output<typeof ErrorTrackingListWidgetConfig>
